<div class="text-center">
  <img src="./assets/Images/Logo2.svg" alt="Logo">
</div>
<div class="mobile-response">
  <div class="card mx-auto">
    <div class="card-body p-0">
      <h3 class="mb-0">Authentifizierung zum Daten-Upload für {{tenantName}}</h3>
      <form [formGroup]="loginForm" class="mt-4">
        @if (!email) {
          @if (emailError && isLinkExpired) {
            <div class="validation-card mt-4 mb-4">
              <i class="icon-exclamation-circle"></i>
              <div>
                <p class="mb-0 error-text"><b>Das Formular ist abgelaufen.</b></p>
                <p class="mb-0 error-text">{{emailError}}</p>
              </div>
            </div>
          }
          <label class="form-label w-100 mb-0" >
            Email<i class="required">*</i>
            <input type="text" formControlName="email" class="form-control" placeholder="Ihre Email"
              [ngClass]="isError || loginForm.get('email')!.invalid && loginForm.get('email')!.touched ? 'invalid' : ''"
              [style]="loginForm.get('email')!.invalid && loginForm.get('email')!.touched ? 'padding-left: 2.25rem;' : '' "
              >
            @if (loginForm.get('email')!.invalid && loginForm.get('email')!.touched) {
              <i class="icon-cancel"></i>
            }
            @if (loginForm.get('email')!.hasError('pattern') && loginForm.get('email')!.touched) {
              <span class="mb-3 error-text-form">Bitte geben Sie ein gültiges E-Mail-Adressformat ein.</span>
            }
            @if (loginForm.get('email')!.hasError('required') && loginForm.get('email')!.touched) {
              <span class="mb-3 error-text-form">Dieses Feld ist erforderlich.</span>
            }
            @if (emailError && !isLinkExpired) {
              <span class="mb-3 error-text-form">{{emailError}}</span>
            }
          </label>
          <button class="btn btn-primary login-btn mx-auto d-flex" [disabled]="loginForm.get('email')!.invalid" (click)="checkEmail()">Authentifizieren</button>
        }
        @if (email) {
          @if (isOtp) {
            <p class="mb-4">Ein einmaliges Passwort wurde an Ihre E-Mail-Adresse gesendet. <span class="new-pass" (click)="getNewPassword()">Fordern Sie einen neuen Code an.</span> </p>
          }
          <label class="form-label w-100 mb-0">
            Passwort<i class="required">*</i>
            <input type="password" formControlName="password" class="form-control" [placeholder]="!isOtp ? 'Bitte geben Sie Ihr Passwort ein' : '*****'"
              [ngClass]="passwordError || (loginForm.get('password')!.hasError('required') && loginForm.get('password')!.touched) ? 'invalid' : ''"
              [style]="loginForm.get('password')!.hasError('required') && loginForm.get('password')!.touched ? 'padding-left: 2.25rem;' : '' ">
            @if (loginForm.get('password')!.hasError('required') && loginForm.get('password')!.touched) {
              <i class="icon-cancel"></i>
            }
            @if (loginForm.get('password')!.hasError('required') && loginForm.get('password')!.touched) {
              <span class="mb-3 error-text-form">Passwort erforderlich.</span>
            }
            @if (passwordError) {
              <span class="mb-3 error-text-form">{{passwordError}}</span>
            }
          </label>
          <button class="btn btn-primary login-btn mx-auto d-flex" [disabled]="loginForm.get('password')!.invalid" (click)="checkPassword()">Authentifizieren</button>
        }
      </form>
    </div>
  </div>
</div>
<footer>
  <a [href]="'https://www.ing-plus.de/datenschutz'" target="_blank"class="link-btn">Datenschutzerklärung</a> |
  <a [href]="'https://www.ing-plus.de/impressum'" target="_blank" class="link-btn">   Impressum </a>
</footer>

